import styled from '@emotion/styled';

import { colors } from 'src/styles';

import { TextCustomProps } from '.';

export const TextElement = styled.p<Required<TextCustomProps>>`
  font-size: ${({ size }) => `${size}rem`};
  font-weight: ${({ weight }) => weight};
  color: ${({ color }) => color || colors.textPrimary};
`;
